import { IUserSearchInfo } from "@/interfaces/User/IUserSearchInfo";

export const mergeUserContexts = (
  user: IUserSearchInfo
):
  | {
      roles: unknown[];
      metadata: {
        businessUnit?: unknown;
      };
    }
  | undefined => {
  if (!user?.contexts?.length) return;

  const manualContext = user.contexts.find(
    (context) =>
      context.contextName.startsWith("VIPER") &&
      !context.contextName.endsWith("-AUTO")
  );
  const viperAutoContexts = user.contexts.filter(
    (context) =>
      context.contextName.startsWith("VIPER") &&
      context.contextName.endsWith("-AUTO")
  );

  const autoContextRoles = viperAutoContexts.flatMap((a) => a.roles);
  const autoContextMetadata = viperAutoContexts.map((a) => a.metadata);
  const mergedAutoContextMetaData = Object.assign({}, ...autoContextMetadata);

  const mergedContext = {
    roles: [...(autoContextRoles || []), ...(manualContext?.roles || [])],
    metadata: {
      ...(mergedAutoContextMetaData || {}),
      ...(manualContext?.metadata || {}),
    },
  };
  //make all the roles unique
  mergedContext.roles = mergedContext.roles.filter(
    (val, idx, arr) => arr.indexOf(val) === idx
  );

  return mergedContext;
};
